import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { forkJoin } from 'rxjs';
import { NotificationTableComponent } from './notification-table/notification-table.component';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisclaimerDailogComponent } from './disclaimer-dailog/disclaimer-dailog.component';
import { AuthStoreService } from '../../../core/auth/auth-store.service';
@Component({
  selector: 'dl-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent implements OnInit {
  public constructor(
    public authStoreService: AuthStoreService,
    private _QnSbnService:QnSbnService, private _cdr: ChangeDetectorRef,
    private readonly dialog?: MatDialog
  ) {}
  public notificationData = [];
  public isDisclaimerAccepted = localStorage.getItem('confidentialAgreed') === 'true';
  public isAuthUser: boolean;
  @ViewChild('notificationTable') public _notificationTable:NotificationTableComponent;
  public ngOnInit(): void {
    this.isAuthUser = this._QnSbnService.isAuthUser;
    // this.notificationData = this._QnSbnService.getNotificationData()[0].notificationOverview;
    if (!this.isDisclaimerAccepted && this.isAuthUser) {
      const dialogRef = this.dialog.open(DisclaimerDailogComponent,{ disableClose: true });;
      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          this.isDisclaimerAccepted = true;
          this._cdr.detectChanges();
        }
      });
    }
  }
}
